module.exports = __webpack_public_path__ + "img/valuationbanner1.26b44427.png";